import { CdkConnectedOverlay } from '@angular/cdk/overlay'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'

import { FlxMessageModule } from '@flowx/angular-ui-toolkit'
import { NavMenuIconsModule } from '@flowx/designer/modules/layout/components/nav-menu/nav-menu-icons.module'
import { FlxNavMenuComponent } from '@flowx/designer/modules/layout/components/nav-menu/nav-menu.component'
import { BranchingOverlayComponent } from '@flowx/designer/modules/process-details/components/branching-overlay/branching-overlay.component'
import { WorkspacesSwitchComponent } from '@flowx/designer/modules/workspaces/shared/workspaces-switch/workspaces-switch.component'
import { BranchNameComponent } from '@flowx/designer/shared/versioning/branch-name/branch-name.component'
import { BranchStateIconComponent } from '@flowx/designer/shared/versioning/branch-state-icon/branch-state-icon.component'

import { MainLayoutComponent } from './components/main-layout/main-layout.component'

@NgModule({
  imports: [
    CommonModule,

    RouterModule,
    NavMenuIconsModule,
    FlxNavMenuComponent,
    BranchNameComponent,
    BranchStateIconComponent,
    BranchingOverlayComponent,
    CdkConnectedOverlay,
    WorkspacesSwitchComponent,
    FlxMessageModule,
    MainLayoutComponent,
  ],
  exports: [],
})
export class LayoutModule {}
